import { useEffect, useState } from "react";
import { getValidToken } from "../utils/getValidToken";
import { useNavigate } from "react-router-dom";

export default function QuizPage() {
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitted, setSubmitted] = useState(false);
  const [score, setScore] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    loadQuestions();
  }, []);

  // ===========================
  // 🔹 LOAD QUESTIONS
  // ===========================
  async function loadQuestions() {
    try {
      const { token } = await getValidToken();

      const response = await fetch(
        "http://localhost:5276/api/quiz/questions",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const json = await response.json();
      setQuestions(json);
    } catch (err) {
      console.error("Error loading quiz:", err);
      alert("Failed to load quiz.");
    } finally {
      setLoading(false);
    }
  }

  // ===========================
  // 🔹 HANDLE SELECT
  // ===========================
  const handleSelect = (qId, selected) => {
    setAnswers((prev) => ({
      ...prev,
      [qId]: selected,
    }));
  };

  // ===========================
  // 🔹 SUBMIT QUIZ
  // ===========================
  async function submitQuiz() {
  try {
    const { token } = await getValidToken();
    const userId = localStorage.getItem("userId");

    if (!userId) {
      alert("User not logged in!");
      return;
    }

    const payload = {
      userId: userId,
      answers: questions.map((q) => ({
  questionId: q.id.toString(),
  selected: answers[q.id] || "",
  correct: q.correct_answer ?? "",   // IMPORTANT FIX
})),

    };

    const response = await fetch("http://localhost:5276/api/quiz/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // you can temporarily remove Authorization if we use [AllowAnonymous]
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    // ✅ NEW: log non-OK responses with status + body
    if (!response.ok) {
      const text = await response.text();
      console.error(
        "Server error:",
        response.status,
        response.statusText,
        text
      );
      alert("Quiz submit failed!");
      return;
    }

    const data = await response.json();
    console.log("Submit result:", data);
    setScore(data.score);
    setSubmitted(true);
  } catch (err) {
    console.error("Submit error (network/JS):", err);
    alert("Failed to submit quiz");
  }
}

  // ===========================
  // 🔹 UI
  // ===========================
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-white">
        Loading quiz...
      </div>
    );
  }

  if (submitted) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center text-white p-5">
        <h1 className="text-3xl font-bold">🎉 Test Completed!</h1>
        <p className="text-xl mt-3">
          Your Score: <span className="text-pink-400">{score}</span> /
          {questions.length}
        </p>

        <button
          onClick={() => navigate("/dashboard")}
          className="mt-6 px-6 py-3 bg-pink-500 rounded-full text-white hover:bg-pink-600"
        >
          Go Back to Dashboard
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#11111f] text-white p-6">
      <h1 className="text-3xl font-bold text-center mb-6">
        🎯 Knowledge Test
      </h1>

      {questions.map((q) => (
        <div
          key={q.id}
          className="bg-[#1c1c2e] p-5 rounded-xl border border-pink-400/20 mb-6"
        >
          <h2 className="text-lg font-semibold mb-3">{q.question}</h2>

          {q.answers &&
            Object.entries(q.answers)
              .filter(([_, v]) => v !== null)
              .map(([key, val]) => (
                <label
                  key={key}
                  className="block mb-2 cursor-pointer hover:text-pink-300"
                >
                  <input
                    type="radio"
                    name={`q-${q.id}`}
                    value={val}
                    checked={answers[q.id] === val}
                    onChange={() => handleSelect(q.id, val)}
                    className="mr-2"
                  />
                  {val}
                </label>
              ))}
        </div>
      ))}

      <button
        onClick={submitQuiz}
        className="w-full bg-pink-500 hover:bg-pink-600 py-4 rounded-xl mt-6 text-xl font-bold"
      >
        Submit Test
      </button>
    </div>
  );
}
